import VehicleOffering from '@carvana/merch-contracts/VehicleOffering';
import { useContext } from 'react';
import AppliedFiltersContext from '~/context/common/AppliedFiltersContext';

export default function useIsNewCarFilterApplied(): boolean {
  const {
    appliedFilters: { offerings }
  } = useContext(AppliedFiltersContext);

  return offerings?.includes(VehicleOffering.New) ?? false;
}
